import { FC, ReactNode } from 'react';
import { Box, BoxProps } from '@mantine/core';

import classes from './index.module.scss';

interface OverlayProps extends BoxProps {
  children: ReactNode;
  showOverlay?: boolean;
  overlayContent?: ReactNode;
  blur?: number;
}

const Overlay: FC<OverlayProps> = ({
  children,
  overlayContent,
  blur = 6,
  showOverlay = false,
  ...containerProps
}) => {
  if (!showOverlay) {
    return <Box {...containerProps}>{children}</Box>;
  }

  return (
    <Box pos="relative" {...containerProps}>
      {children}
      <Box
        className={classes.overlay}
        style={{ backdropFilter: `blur(${blur}px)` }}
      >
        {overlayContent}
      </Box>
    </Box>
  );
};

export default Overlay;
